import { createReducer, on } from '@ngrx/store';
import { loadApiRootSuccessAction } from './api-root.actions';
import { ApiRootResource } from './api-root.model';

export const apiRootFeatureState = 'ApiRootState';

export interface ApiRootState {
	apiRoot: ApiRootResource;
}

export const initialState: ApiRootState = { apiRoot: null };

export const apiRootReducer = createReducer(
	initialState,
	on(loadApiRootSuccessAction, (state: ApiRootState, { apiRoot }): ApiRootState => ({
		...state,
		apiRoot,
	}))
);
